<div class="flex h-screen">
  <pl-navigation #nav class="shrink-0" [pages]="navLinks()" [hideResources]="true">
    <div pl-navigation-header class="flex items-center gap-2">
      <button
        class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full hover:bg-[var(--mat-sys-on-surface)]/10"
        [plNavigationTrigger]="nav"
        [attr.aria-label]="'topbar.toggleNavigation' | transloco"
      >
        <mat-icon class="material-symbols-outlined">menu</mat-icon>
      </button>
      @if (nav.menuOpen) {
        <app-logo class="h-6 w-auto" />
      }
    </div>
    @if (auth.isAuthenticated()) {
      <pl-user-summary
        pl-navigation-footer
        [name]="auth.currentUser()?.name ?? ''"
        [subtitle]="'sidenav.userSubtitle' | transloco"
        [collapsed]="!nav.menuOpen"
      >
        <button mat-menu-item type="button" (click)="auth.logout()">
          <mat-icon class="material-symbols-outlined">logout</mat-icon>
          <span>{{ 'topbar.logOut' | transloco }}</span>
        </button>
      </pl-user-summary>
    }
  </pl-navigation>

  <div class="flex min-w-0 flex-1 flex-col overflow-hidden">
    <pl-topbar class="pl-2 pr-4">
      <button
        pl-topbar-end
        class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full hover:bg-[var(--mat-sys-on-surface)]/10"
        (click)="openSearch()"
        [attr.aria-label]="'topbar.search' | transloco"
      >
        <mat-icon class="material-symbols-outlined">search</mat-icon>
      </button>
      <button
        pl-topbar-end
        class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full hover:bg-[var(--mat-sys-on-surface)]/10"
        (click)="openAiChat()"
        [attr.aria-label]="'topbar.openAiChat' | transloco"
      >
        <mat-icon class="material-symbols-outlined">chat</mat-icon>
      </button>
      <button
        pl-topbar-end
        class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-sm font-semibold uppercase hover:bg-[var(--mat-sys-on-surface)]/10"
        (click)="toggleLanguage()"
        [attr.aria-label]="
          (nextLang() === 'es' ? 'topbar.switchToSpanish' : 'topbar.switchToEnglish') | transloco
        "
      >
        {{ nextLang() }}
      </button>
      <pl-theme-toggle pl-topbar-end />
      @if (!auth.isAuthenticated()) {
        <button
          pl-topbar-end
          class="flex h-10 items-center gap-2 rounded-full px-3 text-sm hover:bg-[var(--mat-sys-on-surface)]/10"
          (click)="auth.login()"
        >
          {{ 'topbar.logIn' | transloco }}
        </button>
      }
    </pl-topbar>

    <div class="flex flex-1 overflow-hidden">
      <pl-drawer
        class="min-w-0 flex-1 overflow-auto"
        [ariaLabel]="'aiChat.label' | transloco"
        mode="docked"
        [open]="drawerOpen()"
        (openedChange)="drawerOpen.set($event)"
      >
        <main class="h-full overflow-auto p-6">
          <div class="mx-auto max-w-2xl">
            <router-outlet />
          </div>
        </main>
        <div
          pl-drawer-panel
          class="flex h-full flex-col items-center justify-center gap-3 p-6 text-center"
        >
          <mat-icon class="material-symbols-outlined text-4xl opacity-40">chat</mat-icon>
          <p class="text-sm text-[var(--mat-sys-on-surface-variant)]">
            {{ 'aiChat.comingSoon' | transloco }}
          </p>
        </div>
      </pl-drawer>
    </div>
  </div>
</div>

<pl-command-palette />
